// GEGENEREERD BESTAND. Niet met de hand aanpassen, CI faalt daarop.
// Bron: packages/protocol/spec/*.json
// Regenereren: php packages/protocol/bin/generate

export const FRAME_RATE = 30;
export const CHANNEL_COUNT = 68;
export const TIMESTAMP_POSITION = 1;
export const REST_VALUE = 0;

export type ChannelOwner = 'api' | 'idle' | 'unused';

export interface ChannelDefinition {
  readonly position: number;
  readonly name: string;
  readonly group: string;
  readonly min: number;
  readonly max: number;
  readonly owner: ChannelOwner;
}

/** De 68 kanalen in wire-volgorde (positie 2..69). Nooit positioneel mappen, altijd op naam. */
export const CHANNELS: readonly ChannelDefinition[] = [
  { position: 2, name: 'eyeBlinkLeft', group: 'leftEye', min: 0, max: 1, owner: 'idle' },
  { position: 3, name: 'eyeLookDownLeft', group: 'leftEye', min: 0, max: 1, owner: 'idle' },
  { position: 4, name: 'eyeLookInLeft', group: 'leftEye', min: 0, max: 1, owner: 'idle' },
  { position: 5, name: 'eyeLookOutLeft', group: 'leftEye', min: 0, max: 1, owner: 'idle' },
  { position: 6, name: 'eyeLookUpLeft', group: 'leftEye', min: 0, max: 1, owner: 'idle' },
  { position: 7, name: 'eyeSquintLeft', group: 'leftEye', min: 0, max: 1, owner: 'api' },
  { position: 8, name: 'eyeWideLeft', group: 'leftEye', min: 0, max: 1, owner: 'api' },
  { position: 9, name: 'eyeBlinkRight', group: 'rightEye', min: 0, max: 1, owner: 'idle' },
  { position: 10, name: 'eyeLookDownRight', group: 'rightEye', min: 0, max: 1, owner: 'idle' },
  { position: 11, name: 'eyeLookInRight', group: 'rightEye', min: 0, max: 1, owner: 'idle' },
  { position: 12, name: 'eyeLookOutRight', group: 'rightEye', min: 0, max: 1, owner: 'idle' },
  { position: 13, name: 'eyeLookUpRight', group: 'rightEye', min: 0, max: 1, owner: 'idle' },
  { position: 14, name: 'eyeSquintRight', group: 'rightEye', min: 0, max: 1, owner: 'api' },
  { position: 15, name: 'eyeWideRight', group: 'rightEye', min: 0, max: 1, owner: 'api' },
  { position: 16, name: 'jawForward', group: 'jaw', min: 0, max: 1, owner: 'api' },
  { position: 17, name: 'jawRight', group: 'jaw', min: 0, max: 1, owner: 'api' },
  { position: 18, name: 'jawLeft', group: 'jaw', min: 0, max: 1, owner: 'api' },
  { position: 19, name: 'jawOpen', group: 'jaw', min: 0, max: 1, owner: 'api' },
  { position: 20, name: 'mouthClose', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 21, name: 'mouthFunnel', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 22, name: 'mouthPucker', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 23, name: 'mouthRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 24, name: 'mouthLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 25, name: 'mouthSmileLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 26, name: 'mouthSmileRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 27, name: 'mouthFrownLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 28, name: 'mouthFrownRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 29, name: 'mouthDimpleLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 30, name: 'mouthDimpleRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 31, name: 'mouthStretchLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 32, name: 'mouthStretchRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 33, name: 'mouthRollLower', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 34, name: 'mouthRollUpper', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 35, name: 'mouthShrugLower', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 36, name: 'mouthShrugUpper', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 37, name: 'mouthPressLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 38, name: 'mouthPressRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 39, name: 'mouthLowerDownLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 40, name: 'mouthLowerDownRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 41, name: 'mouthUpperUpLeft', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 42, name: 'mouthUpperUpRight', group: 'mouth', min: 0, max: 1, owner: 'api' },
  { position: 43, name: 'browDownLeft', group: 'brow', min: 0, max: 1, owner: 'api' },
  { position: 44, name: 'browDownRight', group: 'brow', min: 0, max: 1, owner: 'api' },
  { position: 45, name: 'browInnerUp', group: 'brow', min: 0, max: 1, owner: 'api' },
  { position: 46, name: 'browOuterUpLeft', group: 'brow', min: 0, max: 1, owner: 'api' },
  { position: 47, name: 'browOuterUpRight', group: 'brow', min: 0, max: 1, owner: 'api' },
  { position: 48, name: 'cheekPuff', group: 'cheek', min: 0, max: 1, owner: 'api' },
  { position: 49, name: 'cheekSquintLeft', group: 'cheek', min: 0, max: 1, owner: 'api' },
  { position: 50, name: 'cheekSquintRight', group: 'cheek', min: 0, max: 1, owner: 'api' },
  { position: 51, name: 'noseSneerLeft', group: 'nose', min: 0, max: 1, owner: 'api' },
  { position: 52, name: 'noseSneerRight', group: 'nose', min: 0, max: 1, owner: 'api' },
  { position: 53, name: 'tongueOut', group: 'tongue', min: 0, max: 1, owner: 'api' },
  { position: 54, name: 'headYaw', group: 'headRotation', min: -1, max: 1, owner: 'idle' },
  { position: 55, name: 'headPitch', group: 'headRotation', min: -1, max: 1, owner: 'idle' },
  { position: 56, name: 'headRoll', group: 'headRotation', min: -1, max: 1, owner: 'idle' },
  { position: 57, name: 'leftEyeYaw', group: 'leftEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 58, name: 'leftEyePitch', group: 'leftEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 59, name: 'leftEyeRoll', group: 'leftEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 60, name: 'rightEyeYaw', group: 'rightEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 61, name: 'rightEyePitch', group: 'rightEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 62, name: 'rightEyeRoll', group: 'rightEyeRotation', min: -1, max: 1, owner: 'idle' },
  { position: 63, name: 'angry', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 64, name: 'disgusted', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 65, name: 'fearful', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 66, name: 'happy', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 67, name: 'neutral', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 68, name: 'sad', group: 'emotion', min: 0, max: 1, owner: 'unused' },
  { position: 69, name: 'surprised', group: 'emotion', min: 0, max: 1, owner: 'unused' },
];

export const CHANNEL_NAMES: readonly string[] = CHANNELS.map((c) => c.name);

export const NAME_TO_POSITION: Readonly<Record<string, number>> = Object.fromEntries(
  CHANNELS.map((c) => [c.name, c.position])
);

export const POSITION_TO_NAME: Readonly<Record<number, string>> = Object.fromEntries(
  CHANNELS.map((c) => [c.position, c.name])
);
